import LocalTime from "local-time";

function configureLocalTime() {
  const metadata = document.querySelector('meta[name="local-time-i18n"]');
  if (!metadata) return;

  const { locale, date, time, datetime } = JSON.parse(metadata.content);
  const defaults = LocalTime.config.i18n.en;
  // eslint-disable-next-line security/detect-object-injection -- Rails limits locales to sv/en.
  LocalTime.config.i18n[locale] = {
    ...defaults,
    date: { ...defaults.date, ...date },
    time: { ...defaults.time, ...time },
    datetime: { ...defaults.datetime, ...datetime },
  };
  LocalTime.config.locale = locale;
}

configureLocalTime();
LocalTime.start();

// Turbo merges the new head before replacing the body. Set the locale before
// LocalTime's observer processes any dates in that body, including previews.
document.addEventListener("turbo:before-render", configureLocalTime);
document.addEventListener("turbo:morph", () => {
  configureLocalTime();
  LocalTime.process(...document.querySelectorAll("time[data-local]"));
});
